import axios, { AxiosRequestConfig } from 'axios'

export const createInstance = (baseUrl: string, options: AxiosRequestConfig = {}, isForm = false) => {
  const api = axios.create({
    ...options,
    baseURL: baseUrl,
    headers: {
      ...options.headers || {},
      'Accept': 'application/json',
      'Content-Type': isForm ? 'multipart/form-data' : 'application/json; charset=utf-8'
    },
    responseType: 'json'
  })
  api.interceptors.response.use(
    response => response,
    async error => {
      const config = error.config
      config.retryCount = config.retryCount || 0

      if (!config || !config.retry) {
        return Promise.reject(error)
      }

      if (config.retryCount >= config.retry) {
        return Promise.reject(error)
      }

      config.retryCount += 1

      const delay = new Promise<void>( (resolve) => {
        setTimeout(() => {
          resolve()
        }, config.retryDelay || 100)
      })

      await delay
      return api.request(config)
    })
  return api
}
